import * as React from 'react';

import { PageTitle } from './page-title';

export class CateringPage extends React.PureComponent {
  public render() {
    return (
      <div className="catering-page">
        <PageTitle text="Catering" />
      </div>
    );
  }
}
